import { List, Record } from 'immutable';
import { DEFAULT_PER_PAGE } from '../constants';

export const OrderList = new Record({
  id: null,
  isNew: true,
  isPending: false,
  orderIds: new List(),
  total: 0,
  count: 0,
  hasNextPage: false,
  hasPrevPage: false,
  filters: null,
  currentPage: 0,
  last_page: 0,
  per_page: DEFAULT_PER_PAGE,
  prevUrl: null,
  nextUrl: null,
  from: 0,
  to: 0,
  hasNextPageInStore: false,
  pageCount: 0,
  created_at: new Date(),
});
